// 旧路由重定向（C1.3 冻结表）：被 Tab 壳吸收的旧地址 → 壳基路径 + 对应 ?tab=
// 语义等同 301（replace）；业务 query 原样透传，tab 由映射覆盖写入（对齐 cardCenterRoutes 口径）。
// 注意：营销中心组路由不挂重定向（PRD 明文本期不可达，直接 404 不伪装）；
// /merchant/messages 路由保留（消息组出菜单后由 Header 铃铛接管入口）。
import { Navigate, useLocation } from 'react-router-dom';

/** 旧路由 → 壳 Tab 重定向映射（from 为相对 /merchant 段，供 App.tsx 内 Route 注册） */
interface LegacyTabRoute {
  /** 旧路由相对 /merchant 的 path */
  from: string;
  /** 壳基路径（绝对） */
  to: string;
  /** 重定向后落地的 Tab 值 */
  tab: string;
}

/**
 * 被 Tab 壳吸收的旧路由清单（freeze 表逐条核对）：
 * - channel/topup|rates|fee-items      → /merchant/channel
 * - channel/physical-apply|cards       → /merchant/card/issue-center（实体卡并入新卡管理）
 * - kyc/fill|fines                     → /merchant/kyc
 * - risk/users                         → /merchant/risk/radar
 * - risk/quick-actions                 → /merchant/risk/rules（actions Tab，无权限时壳内回退首 Tab）
 * - business/recharge-config           → /merchant/finance/channel
 * - business/deposits                  → /merchant/finance/users
 * - brand                              → /merchant/settings/account
 * - settings/webhooks|developer-docs   → /merchant/settings/api-keys
 * - settings/email-templates           → /merchant/settings/email-channels
 * - settings/logs                      → /merchant/settings/security
 */
export const LEGACY_TAB_REDIRECTS: readonly LegacyTabRoute[] = [
  { from: 'channel/topup', to: '/merchant/channel', tab: 'topup' },
  { from: 'channel/rates', to: '/merchant/channel', tab: 'rates' },
  { from: 'channel/fee-items', to: '/merchant/channel', tab: 'fee-items' },
  { from: 'channel/physical-apply', to: '/merchant/card/issue-center', tab: 'PHYSICAL_APPLY' },
  { from: 'channel/physical-cards', to: '/merchant/card/issue-center', tab: 'PHYSICAL_CARDS' },
  { from: 'kyc/fill', to: '/merchant/kyc', tab: 'fill' },
  { from: 'kyc/fines', to: '/merchant/kyc', tab: 'fines' },
  { from: 'risk/users', to: '/merchant/risk/radar', tab: 'users' },
  { from: 'risk/quick-actions', to: '/merchant/risk/rules', tab: 'actions' },
  { from: 'business/recharge-config', to: '/merchant/finance/channel', tab: 'recharge-config' },
  { from: 'business/deposits', to: '/merchant/finance/users', tab: 'deposits' },
  { from: 'brand', to: '/merchant/settings/account', tab: 'brand' },
  { from: 'settings/webhooks', to: '/merchant/settings/api-keys', tab: 'webhooks' },
  { from: 'settings/developer-docs', to: '/merchant/settings/api-keys', tab: 'docs' },
  { from: 'settings/email-templates', to: '/merchant/settings/email-channels', tab: 'templates' },
  { from: 'settings/logs', to: '/merchant/settings/security', tab: 'logs' },
];

/**
 * 旧地址重定向组件：tab 按映射覆盖写入，其余业务 query 原样透传（深链不丢参数）。
 */
export function LegacyTabRedirect({ to, tab }: { to: string; tab: string }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('tab', tab);
  return <Navigate to={`${to}?${params.toString()}`} replace />;
}
